
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/avatar-dialog-view/jst/uploadFileView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <div class=\"row-fluid\">\n    <div class=\"span6\">\n      <p>\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("profiles.upload_file_view")
  },data:data},helper ? helper.call(depth0, "profiles.upload_file_view.crop_instructions", "To crop the image, drag the selection with the mouse or use the arrow keys to move the selection and shift+arrow keys to resize the selection. Then click the \"Save\" button below.", options) : helperMissing.call(depth0, "t", "profiles.upload_file_view.crop_instructions", "To crop the image, drag the selection with the mouse or use the arrow keys to move the selection and shift+arrow keys to resize the selection. Then click the \"Save\" button below.", options)))
    + "\n      </p>\n    </div>\n    <div class=\"span6 text-center avatar-preview-wrapper\">\n      <div class=\"avatar-preview\"></div>\n    </div>\n  </div>\n";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <a class=\"select-photo-link\" href=\"#\">\n    <i class=\"icon-image icon-select-photo\"></i>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("profiles.upload_file_view")
  },data:data},helper ? helper.call(depth0, "profiles.upload_file_view.choose_a_picture", "choose a picture", options) : helperMissing.call(depth0, "t", "profiles.upload_file_view.choose_a_picture", "choose a picture", options)))
    + "\n  </a>\n\n  <input id=\"selected-photo\" type=\"file\" class=\"hidden\" accept=\"image/*\" />\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasPreview), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  